import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style/animate.min.css'
import './style/aos.css'
import './style/bootstrap.min.css'
import './style/bootstrap-icons/bootstrap-icons.css'
import './style/header.css'
import useElement from "./plugins/element";
import { vuePlugin as api } from "./api/index.js";
import customizeTips from './plugins/tips' 

import './style/tailwindcss.pcss'
import './style/layout.scss'

let app = createApp(App).use(router);
app.use(useElement).use(api).use(customizeTips).mount('#app')
